import { find } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import golApi from "shared/gol-api/index";
import { getPassenger } from "shared/lib/golObjectTypes/Passenger/passenger";
import { BookingFormPassengerSection, PassengersType } from "shared/types";

import { setBookingFormFieldValue } from "../../data/actions/bookingForm";
import { AppState } from "../../data/reducers";

type BookingFormPassengerSectionProps = {
  bookingFormPassengerSection: BookingFormPassengerSection;
  dataVersion: number;
};

export function useBookingFormPassengerSections({
  bookingFormPassengerSection,
  dataVersion,
}: BookingFormPassengerSectionProps): {
  setTravelersFieldsFromProfile: (traveler) => void;
  passengers: PassengersType;
} {
  const { bookingFormFields } = useSelector((state: AppState) => ({
    bookingFormFields: state.bookingForm.bookingFormFields,
  }));

  const [allPassengers, setAllPassengers] = useState<PassengersType>([]);

  const dispatch = useDispatch();

  async function loadData() {
    const customerDetail = await golApi.detailCustomer2();

    if (customerDetail.success) {
      const formattedCustomer = {
        ...customerDetail.data.formattedData,
        isOwner: true,
      };

      const customerPassengersDetail =
        customerDetail.data.CustomerPassengers?.CustomerPassenger || [];

      const customerPassengersArray =
        (await Promise.all(
          customerPassengersDetail.map(async (passenger) => {
            const customerPassenger = await getPassenger(passenger.PassengerId);
            return customerPassenger.data;
          })
        )) ?? [];

      await setAllPassengers([formattedCustomer, ...customerPassengersArray]);
    }
  }

  useEffect(() => {
    loadData();
  }, [dataVersion]);

  const formateTraveler = (traveler) => ({
    birth_date: traveler.birthDate,
    lastname: traveler.surname,
    title: traveler.namePrefix.toUpperCase(),
    ...traveler,
  });

  const setTravelersFieldsFromProfile = (traveler) => {
    const travelerFormated = formateTraveler(traveler);

    Object.keys(travelerFormated).forEach((key) => {
      const value = travelerFormated[key];
      const fullFieldName = find(
        bookingFormPassengerSection.elements,
        (item) => {
          return item.includes(key);
        }
      );

      if (fullFieldName) {
        dispatch(
          setBookingFormFieldValue(fullFieldName, {
            ...bookingFormFields[fullFieldName],
            value,
          })
        );
      }
    });
  };

  return {
    setTravelersFieldsFromProfile,
    passengers: allPassengers,
  };
}
